/** 生产环境站点根路径（与 vite build --base 一致，末尾无斜杠） */
export const SITE_ORIGIN = import.meta.env.VITE_SITE_URL ?? 'https://www.ai4learn.cn/fpstrain'

export const SITE_NAME = 'FpsTrain'
export const SITE_TAGLINE = '让每一枪都爽'
export const SITE_TITLE = `${SITE_NAME} · ${SITE_TAGLINE}`

export const SITE_DESCRIPTION =
  'FpsTrain 是免费在线 FPS 枪法训练器：Gridshot 甩枪、连击火热档、任务成就与数据复盘。无需下载，浏览器开练，适合 Valorant、CS2、Apex 开黑前热身。'

export const SITE_KEYWORDS = [
  'FPS训练',
  '枪法训练',
  '瞄准训练',
  'Gridshot',
  '甩枪练习',
  'Valorant练枪',
  'CS2练枪',
  'Apex练枪',
  '在线靶场',
  'aim trainer',
  'fps aim trainer',
  '网页练枪',
].join(', ')

export const SHARE_TEXT =
  '我在用 FpsTrain 练甩枪，60 秒一局、连击越打越燃，开黑前热身刚刚好。'

export const OG_IMAGE = `${SITE_ORIGIN}/og-image.svg`

export function absoluteUrl(path = ''): string {
  const base = SITE_ORIGIN.replace(/\/$/, '')
  if (!path) return base
  return `${base}${path.startsWith('/') ? path : `/${path}`}`
}
